export default class RGB
{
    public r:number;
    public g:number;
    public b:number;
}
